



















































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { email, required } from 'vuelidate/lib/validators';
import InvalidForm from '../../../components/shared/InvalidForm.vue';
import { FieldStateMixin } from '../../../utils/FieldStateMixin';

const RECAPTCHA_SITE_KEY = '6Lf1qactAAAAANAHmz4lgBApyxUh9lilXvQhJnsB';
const RECAPTCHA_ACTION = 'RESET_PASSWORD';

declare const grecaptcha: {
  enterprise: {
    ready: (callback: () => void) => void;
    execute: (siteKey: string, options: { action: string }) => Promise<string>;
  };
};

@Component({
  components: { InvalidForm },
  validations: {
    email: { required, email },
  },
})
export default class PasswordReset extends Mixins(FieldStateMixin) {
  public email: string = null;

  public error: boolean = false;
  public success: boolean = false;
  public loading: boolean = false;

  public resetPassword(event: Event) {
    event.preventDefault();
    this.loading = true;
    new Promise<string>((resolve) => {
      grecaptcha.enterprise.ready(() => {
        resolve(grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action: RECAPTCHA_ACTION }));
      });
    })
      .then((token) => {
        this.$http.post('api/auth/reset_password/', { email: this.email, token }).then(
          (result: any) => {
            this.loading = false;
            this.success = true;
            this.email = null;
          },
          (error: any) => {
            this.loading = false;
            this.error = true;
            this.email = null;
          },
        );
      })
      .catch(() => {
        this.loading = false;
        this.error = true;
      });
  }
}
